import 'css-chunksrc/client/pages/eventPage/details/styles.scss';export default {
  "details": "_details_1xavl_1",
  "name": "_name_1xavl_5",
  "input": "_input_1xavl_15",
  "description": "_description_1xavl_25",
  "label": "_label_1xavl_29",
  "paragraph": "_paragraph_1xavl_35",
  "advancement": "_advancement_1xavl_45",
  "percentage": "_percentage_1xavl_52",
  "progressBar": "_progressBar_1xavl_61",
  "percentageText": "_percentageText_1xavl_66",
  "advancementLabel": "_advancementLabel_1xavl_72",
  "descriptionMaxChars": "_descriptionMaxChars_1xavl_79",
  "loader": "_loader_1xavl_84",
  "loaderMain": "_loaderMain_1xavl_92"
};